import {BicycleTypeEnum} from "./AnswerEnums";

export class BicycleType {
    public static readonly CITY_COMFORT: BicycleType = new BicycleType(
        BicycleTypeEnum.cityComfort.toString(),
        'City',
        "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/city_comfort.png",
    );
    public static readonly TREKKING_COMFORT: BicycleType = new BicycleType(
        BicycleTypeEnum.trekkingComfort.toString(),
        'Trekking Comfort',
        "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/trekking_comfort.png",
    );
    public static readonly TREKKING_CROSS: BicycleType = new BicycleType(
        BicycleTypeEnum.trekkingCross.toString(),
        'Trekking Sport',
        "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/trekking_cross.png",
    );
    public static readonly MTB_ALL_MOUNTAIN: BicycleType = new BicycleType(
        BicycleTypeEnum.mountainBikeAllMountain.toString(),
        'MTB All Mountain & Enduro',
        "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/mtb_all_mountain.png",
    );
    public static readonly MTB_XC: BicycleType = new BicycleType(
        BicycleTypeEnum.mountainBikeCrossCountry.toString(),
        'MTB Trail & Down Country',
        "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/mtb_xc.png",
    );
    public static readonly GRAVEL: BicycleType = new BicycleType(
        BicycleTypeEnum.gravel.toString(),
        'Gravel',
        "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/gravel.png",
    );
    public static readonly RACING_BIKE: BicycleType = new BicycleType(
        BicycleTypeEnum.racingBike.toString(),
        'Rennrad',
        "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/racing_bike.png",
    );
    public static readonly TRIATHLON_BIKE: BicycleType = new BicycleType(
        BicycleTypeEnum.triathlon.toString(),
        'Triathlon',
        "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/triathlon_bike.png",
    );

    // Trial & BMX, MTB Dirt & Downhill are removed (Max Holz 2026-04-28).

    // public static readonly TRIAL_BMX: BicycleType = new BicycleType(
    //     BicycleTypeEnum.trialBmx.toString(),
    //     'Trial & BMX',
    //     "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/mtb_xc.png",
    // );

    // public static readonly MTB_DOWNHILL: BicycleType = new BicycleType(
    //     BicycleTypeEnum.mtbDownhill.toString(),
    //     'MTB Dirt & Downhill',
    //     "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/mtb_all_mountain.png",
    // );

    public static readonly MTB_MARATHON: BicycleType = new BicycleType(
        BicycleTypeEnum.mtbMarathon.toString(),
        'MTB Marathon & Cross Country',
        "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/mtb_all_mountain.png",
    );

    public static readonly ROAD_RACE: BicycleType = new BicycleType(
        BicycleTypeEnum.roadRace.toString(),
        'Road Race',
        "https://static-assets-bpj.pages.dev/profiler/email-images/bike_profile/racing_bike.png",
    );

    private constructor(
        public readonly internalId: string,
        public readonly name: string,
        public readonly imageUrl: string,
    ) {
    }

    public static byInternalId(id: string): BicycleType | undefined {
        return Object.values(BicycleType).find((b) => b.internalId === id);
    }
}